import Vue from 'vue'
import Router from 'vue-router'
import LoginPage from '../components/LoginPage'
import EnergyEfficiency from '../components/EnergyEfficiency/EnergyEfficiency'
import PdfDetail from '../components/EnergyEfficiency/FormManage/ReportDetail'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'LoginPage',
      component: LoginPage
    },
    {
      path: '/energy-efficiency',
      name: 'EnergyEfficiency',
      component: EnergyEfficiency
    },
    {
      path: '/pdf-detail',
      name: 'PdfDetail',
      component: PdfDetail
    }
  ]
})

export function routerTo (router, name, data) {
  router.push({
    name: name,
    // 选择使用query进行传参而不使用params，防止使用params出现强制刷新时参数丢失
    // 使用中发现query中数据为object，刷新后异常无法解析，而使用JSON.stringify后会使参数全部添加到url后面
    query: data
  })
}



// WEBPACK FOOTER //
// ./src/router/index.js